export default "__VITE_ASSET__BwPc2NrO__"